module.exports = __webpack_public_path__ + "media/images/smart_phone/login/202001/logo_01-5aec4fe88de33d8a8bb521fc343befd9.png";